import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Package, Settings as SettingsIcon, Users, LogOut, Menu, X, Truck, UserCircle, FileText, Globe, Building2, Image, Smartphone, KeyRound } from 'lucide-react';

export default function Layout() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const [lang, setLang] = useState(localStorage.getItem('admin_lang') || 'en');
  const [t, setT] = useState({});
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const loadT = async (l) => {
    try {
      const res = await fetch('https://api.ctexpresskh.com/api/translations/' + l);
      const data = await res.json();
      setT(data.data || {});
      window._t = data.data || {};
    } catch {}
  };

  const changeLang = (l) => {
    setLang(l);
    localStorage.setItem('admin_lang', l);
    loadT(l);
  };

  React.useEffect(() => { loadT(lang); }, []);

  const tr = (key, fallback) => t[key] || fallback || key;

  const logout = () => {
    localStorage.clear();
    navigate('/login');
  };

  const links = [
    { to: '/', icon: <LayoutDashboard size={20} />, label: tr('nav_dashboard','Dashboard') },
    { to: '/shipments', icon: <Package size={20} />, label: tr('nav_shipments','Shipments') },
    { to: '/rates', icon: <SettingsIcon size={20} />, label: tr('nav_rates','Shipping Rates') },
    { to: '/customers', icon: <UserCircle size={20} />, label: tr('nav_customers','Customers') },
    { to: '/reports', icon: <FileText size={20} />, label: tr('nav_reports','Reports') },
    { to: '/languages', icon: <Globe size={20} />, label: tr('nav_languages','Languages') },
    { to: '/slideshows', icon: <Image size={20} />, label: 'Slideshows' },
    { to: '/mobile-translations', icon: <Smartphone size={20} />, label: 'Mobile Translations' },
    { to: '/mobile-users', icon: <KeyRound size={20} />, label: 'Mobile Users' },
    { to: '/app-version', icon: <Smartphone size={20} />, label: 'App Version' },
    { to: '/exchange-rates', icon: <Smartphone size={20} />, label: 'Exchange Rates' },
    { to: '/news-feed', icon: <Image size={20} />, label: 'News Feed' },
    { to: '/settings', icon: <Building2 size={20} />, label: tr('nav_settings','Settings') },
    { to: 'https://track.ctexpresskh.com', icon: <Globe size={20} />, label: tr('nav_track','តាមដាន'), external: true },
    { to: '/users', icon: <Users size={20} />, label: tr('nav_users','Users') },
  ];

  return (
    <div style={{ display: 'flex', minHeight: '100vh', fontFamily: 'sans-serif' }}>
      {/* Sidebar */}
      <div style={{ width: open ? 240 : 60, background: '#1e293b', color: '#fff', transition: 'width 0.3s', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '16px', display: 'flex', alignItems: 'center', gap: 10, borderBottom: '1px solid #334155' }}>
          <Truck size={24} color="#f97316" />
          {open && <span style={{ fontWeight: 'bold', fontSize: 16 }}>CT Express</span>}
          <button onClick={() => setOpen(!open)} style={{ marginLeft: 'auto', background: 'none', border: 'none', color: '#fff', cursor: 'pointer' }}>
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
        {open && (
          <div style={{ padding: '8px 16px', borderBottom: '1px solid #334155', display: 'flex', gap: 6 }}>
            {['en','kh','cn'].map(l => (
              <button key={l} onClick={() => changeLang(l)}
                style={{ flex: 1, padding: '4px 0', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 11, fontWeight: 700,
                  background: lang === l ? '#f97316' : '#334155',
                  color: lang === l ? '#fff' : '#94a3b8' }}>
                {l.toUpperCase()}
              </button>
            ))}
          </div>
        )}
        <nav style={{ flex: 1, padding: '8px 0' }}>
          {links.map(link => (
            <NavLink key={link.to} to={link.to} end={link.to === '/'}
              style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px',
                color: isActive ? '#f97316' : '#94a3b8', textDecoration: 'none',
                background: isActive ? '#0f172a' : 'transparent',
                borderLeft: isActive ? '3px solid #f97316' : '3px solid transparent',
              })}>
              {link.icon}
              {open && <span>{link.label}</span>}
            </NavLink>
          ))}
        </nav>
        <div style={{ padding: '8px 16px', borderTop: '1px solid #1e3a5f', textAlign: 'center' }}>
          <div style={{ fontSize: 9, color: '#475569' }}>Developed by Ven Sophanith</div>
        </div>
        <div style={{ padding: 16, borderTop: '1px solid #334155' }}>
          {open && <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 8 }}>{user.name}<br /><span style={{ color: '#f97316' }}>{user.role}</span></div>}
          <button onClick={logout} style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: 4 }}>
            <LogOut size={18} />
            {open && <span>Logout</span>}
          </button>
        </div>
      </div>

      {/* Main content */}
      <div style={{ flex: 1, background: '#f1f5f9', overflow: 'auto' }}>
        <Outlet />
      </div>
    </div>
  );
}
